import { render } from "./About.vue?vue&type=template&id=4938d506&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=4938d506&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-4938d506"

export default script